<div class="d-flex align-items-center gap-2">
  <i class="material-icons">center_focus_strong</i>
  <span [ngClass]="size">{{ "BASE_COLLECTION" | translate }}</span>
</div>
